<template id="player_add">
  <player-data />
</template>

<script>
import PlayerData from "@/components/PlayerData.vue";
export default {
  components: {
    PlayerData,
  },
};
</script>
